/* Enord Core classic v1.0 — Compare cards mobile slider arrows */
(function(){
  function init(root){
    if(root.__ecm)return;root.__ecm=1;
    var tr=root.querySelector('[data-ecm-track]'),pv=root.querySelector('[data-ecm-prev]'),nx=root.querySelector('[data-ecm-next]');
    if(!tr)return;
    function step(){var s=tr.querySelector('.ecm-slide');return s?s.getBoundingClientRect().width:tr.clientWidth}
    function sync(){var m=window.matchMedia('(max-width:767.5px)').matches,max=tr.scrollWidth-tr.clientWidth-2;
      if(pv)pv.style.visibility=(!m||tr.scrollLeft<=2)?'hidden':'visible';
      if(nx)nx.style.visibility=(!m||tr.scrollLeft>=max)?'hidden':'visible'}
    var tm;tr.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(sync,40)},{passive:true});
    if(pv)pv.addEventListener('click',function(){tr.scrollBy({left:-step(),behavior:'smooth'})});
    if(nx)nx.addEventListener('click',function(){tr.scrollBy({left:step(),behavior:'smooth'})});
    window.addEventListener('resize',sync);sync();
  }
  function all(){document.querySelectorAll('[data-ecm]').forEach(init)}
  all();document.addEventListener('shopify:section:load',all);
})();
